import React from 'react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Typography, Checkbox, Box, ListItem } from '@mui/material';
import * as fieldListStyle from './FieldListStyle';

class FieldCard extends React.Component {
  handleCheckboxChange = (event) => {
    const { handleCheckbox, field } = this.props;
    handleCheckbox(event, field.fieldId);
  };

  render() {
    const { field, checked, disable } = this.props;

    return (
      <li className="show-checkbox list-item full-width" style={{ borderBottom: '1px solid #BEC8C9', padding: '0px', margin: '0px' }}>
        <div className="checkbox-holder">
          <span>
            <Checkbox
              checked={checked || false}
              id={field.fieldId}
              onChange={this.handleCheckboxChange}
              sx={{
                color: '#000',
                '&.Mui-checked': { color: '#00696D' },
              }}
              disabled={disable}
            />
          </span>
        </div>
        <Link
          to={`/managefields/${field.fieldId}`}
          className={`field-list-item-link ${disable ? 'disabled' : ''}`}
          style={{ textDecoration: 'none', border: 'none', boxShadow: 'none', background: 'none', width: '100%', height: '72px' }}
        >
          <ListItem style={{ ...fieldListStyle.listItemStyleLayout, alignItems: 'flex-start', margin: '0px', padding: '0px', width: '100%' }}>
            <Box style={{ display: 'flex', width: '100%' }}>
              <Box style={{ flex: 2, /*padding: '12px 16px',*/ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                {field.fieldSize && <Typography style={fieldListStyle.listRowSubItem}>{field.fieldSize} daa</Typography>}
                <Typography sx={{
                  color: 'var(--M3-sys-light-on-surface, #191C1C)',
                  fontFamily: 'Inter',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '24px',
                  letterSpacing: '0.5px',
                  paddingRight: '8px',
                  width: '180px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis', // ... Truncate text
                  whiteSpace: 'nowrap',
                  paddingBottom: '10px'
                }}>{field.displayName}</Typography>
              </Box>
              <Box style={{ flex: 1, padding: '12px 0px 12px 16px', display: 'flex', justifyContent: 'flex-end' }}>
                <Typography style={fieldListStyle.listItemTextStyle}>
                  {field.currentTempSum || '--'}
                </Typography>
              </Box>
            </Box>
          </ListItem>
        </Link>
      </li>
    );
  }
}

export default injectIntl(FieldCard);